// Components==============
import eventsIndex from 'actions/events/index';
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import HeroLayout from 'components/UI/HeroLayout';
import React, { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import EventCard from './components/EventCard';
import EventsCardModal from './components/EventCardModal';
import Filter from './components/Filter';
import './index.module.scss';
import SubscriptionModal from 'components/UI/trainingModals/SubscriptionModal';
// =========================

export const AgendaContext = createContext(null);

export default function Agenda() {
    const [searchValue, setSearchValue] = useState('');
    const [networkChecked, setNetworkChecked] = useState(false);
    // const [networkChecked, setNetworkChecked] = useState(isNetwork);
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(
        new Date().setMonth(new Date().getMonth() + 12)
    );
    const dispatch = useDispatch();

    useEffect(() => {
        const localstorageNetworkChecked = localStorage.getItem(
            'networkCheckbox'
        );
        if (localstorageNetworkChecked === 'true') {
            setNetworkChecked(true);
            localStorage.setItem('networkCheckbox', false);
        }

        dispatch(eventsIndex());
    }, []);

    const formattedDate = (date) => {
        const d = new Date(date);
        const month = d.toLocaleString('nl-NL', {
            timeZone: 'Europe/Amsterdam',
            month: 'long',
        });
        const year = d.getFullYear();
        return `${month} ${year}`;
    };

    const events = useSelector((state) =>
        state?.events?.entities?.allIds?.map(
            (id) => state?.events?.entities?.byId[id]
        )
    );

    const allEvents = [...events]
        .filter((agenda) => agenda.start_date !== null)
        .sort(
            (a, b) =>
                new Date(a.start_date || a.date) -
                new Date(b.start_date || b.date)
        )
        ?.filter((agenda) =>
            searchValue.length
                ? agenda.title.toLowerCase().includes(searchValue.toLowerCase())
                : true
        )
        ?.filter((agenda) =>
            selectedStartDate
                ? new Date(agenda.start_date || agenda.date) >=
                  selectedStartDate
                : true
        )
        ?.filter((agenda) =>
            selectedEndDate
                ? new Date(agenda.start_date || agenda.date) <= selectedEndDate
                : true
        )
        ?.filter((agenda) => (networkChecked ? agenda.is_network_event : true));

    const dates = allEvents?.map((e) =>
        formattedDate(e?.start_date || e?.date)
    );

    const { pathname } = useLocation();
    const urlId = pathname?.split('/')?.[3];
    const eventActiveModal = allEvents?.find((t) => urlId === `${t.id}`);

    return (
        <AgendaContext.Provider
            value={{
                searchValue,
                setSearchValue,
                selectedStartDate,
                setSelectedStartDate,
                selectedEndDate,
                setSelectedEndDate,
                networkChecked,
                setNetworkChecked,
            }}
        >
            <Layout>
                <Container>
                    <HeroLayout>
                        <div styleName="container">
                            <div styleName="item ">
                                <Filter />
                            </div>
                            <div styleName="item">
                                {allEvents.length ? (
                                    allEvents?.map((e, i) => (
                                        // eslint-disable-next-line react/jsx-key
                                        <>
                                            {dates[i] !== dates[i - 1] && (
                                                <h1 styleName="date" key={i}>
                                                    {dates[i].toUpperCase()}
                                                </h1>
                                            )}
                                            <EventCard
                                                key={i}
                                                id={e?.id}
                                                title={e?.title || e?.name}
                                                date={e?.date || e?.start_date}
                                            />
                                        </>
                                    ))
                                ) : (
                                    <h1 styleName="no-events ">
                                        Er zijn geen evenementen gevonden
                                    </h1>
                                )}
                            </div>
                        </div>
                        <EventsCardModal events={eventActiveModal} />
                        <SubscriptionModal training={eventActiveModal} isAgendaPage />
                    </HeroLayout>
                </Container>
            </Layout>
        </AgendaContext.Provider>
    );
}
